function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 387.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M449.35,233.08A43.77,43.77,0,0,0,443.7,217a42.88,42.88,0,0,0-5.09-7,44.38,44.38,0,0,0-6.26-5.74,45.12,45.12,0,0,0-7.4-4.47,43.64,43.64,0,0,0-8.06-3,44.56,44.56,0,0,0-8.44-1.32c-.83-.05-1.56-.06-2.3-.06a46.76,46.76,0,0,0-6.22.42,43.88,43.88,0,0,0-8.42,2.07,45.07,45.07,0,0,0-7.81,3.6,45.69,45.69,0,0,0-6.88,5,43.14,43.14,0,0,0-5.84,6.39,44,44,0,0,0-7.41,15.45,43.39,43.39,0,0,0-1.33,8.44,44.16,44.16,0,0,0,.38,8.6,44.93,44.93,0,0,0,5.65,16.1A43.74,43.74,0,0,0,387,278.72a43.33,43.33,0,0,0,8.09,3,42.21,42.21,0,0,0,8.46,1.33c.8,0,1.54.06,2.29.06a44.27,44.27,0,0,0,6.18-.43,43.8,43.8,0,0,0,8.43-2.07,42.59,42.59,0,0,0,7.82-3.62,45.66,45.66,0,0,0,6.86-5A44.32,44.32,0,0,0,441,265.6a43.12,43.12,0,0,0,4.45-7.37,45.12,45.12,0,0,0,3-8l0-.07v-.07a43.33,43.33,0,0,0,1.3-8.43A42.11,42.11,0,0,0,449.35,233.08Zm-25.07,38a34.25,34.25,0,0,1-39.76-3.89,34.37,34.37,0,1,1,56.42-32.58,35,35,0,0,1-.11,13.94A34.6,34.6,0,0,1,424.46,271l-.1.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.37,236.24a46.2,46.2,0,0,0-6.85-7.62,32.75,32.75,0,0,0-15.3-7.34,47.33,47.33,0,0,0-10.24-.61,15.15,15.15,0,0,1,9.91-6.6,19.89,19.89,0,0,1,21.44,10.32A15.15,15.15,0,0,1,427.37,236.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.22,325.27l.11,1.48a130.72,130.72,0,0,0-21-13.5,161.89,161.89,0,0,0-23.2-9.56,225.09,225.09,0,0,0-49.29-9.59,337.55,337.55,0,0,0-50.28-.26,367.05,367.05,0,0,0-44.37,5.81c.34-18.37.45-36.73.71-55.1L99.16,184,99,123.46l-.25-22.68L89.17,89.33h-17l1.4,230.36c133.49-26.05,217.13,11,217.13,11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.32,313.25a161.89,161.89,0,0,0-23.2-9.56,225.09,225.09,0,0,0-49.29-9.59,337.55,337.55,0,0,0-50.28-.26,367.05,367.05,0,0,0-44.37,5.81c.34-18.37.45-36.73.71-55.1L99.16,184,99,123.46l-.61-56.91a311.55,311.55,0,0,1,41.09-7.2,277.34,277.34,0,0,1,45.46-1.46c15.12.91,30.24,3.18,44.62,8.09s28,12.3,39.13,23h0a93.85,93.85,0,0,0-17.36-15.29,113.76,113.76,0,0,0-20.56-10.94A166.46,166.46,0,0,0,185.4,52a264.44,264.44,0,0,0-46.66-.46,314,314,0,0,0-46.3,6.9L89,59.18l0,3.73-.65,60.55L88.13,184l.28,60.55c.28,20.18.38,40.37.81,60.55l.11,5.62,5.39-1.32a356.61,356.61,0,0,1,48.46-8.09,329.75,329.75,0,0,1,49.28-1.6,226.88,226.88,0,0,1,48.76,7,160.43,160.43,0,0,1,23.36,8.07,130.31,130.31,0,0,1,21.75,11.93A130.72,130.72,0,0,0,265.32,313.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8,135.15c28.55,63,56.09,53.38,75.47,65.53,27.33,17.13,27.81,24.93,1.27,100.09C217,283.23,221,219.42,209.33,167.12c-7.15-32-20.19-59.62-36.26-69.81C226.54,171.88,156.62,207.43,107.8,135.15Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.74,273c.91,11.16,2.5,26.36,2.74,25.66,8.4-23.72,12.67-40.84,7-70.39q-.09,3.15-.3,6.27A118.14,118.14,0,0,1,210.74,273Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.94,127.84a15.36,15.36,0,1,1-15.15,15.72A15.44,15.44,0,0,1,162.94,127.84Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,198.33,162.41,265s53.11,2.84,78.18-15.75-30.66-67.58-30.66-67.58Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,250.61c5.64,9.68,11.51,18.73,10.91,18.3-20.46-14.66-31.72-22.29-44-49.77q1.88,2.54,3.84,5C263.73,233.74,273.78,243.67,285.22,250.61Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,115.06a15.36,15.36,0,1,0,21.42,4.23A15.44,15.44,0,0,0,242.79,115.06Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.82,132s-19.59-4.89-12.26,29.87C139.56,161.89,157.21,137.58,151.82,132Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.92,229.94l-.86-2.34c-49.57-53.09,23.38-68,2.9-150.76,1.27,87.21-74.16,102.41-72.94,10.65C198.45,127,243.67,227.52,294,251.86Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522,249.05l-6.63-16.16-6.54-16.19-13.05-32.34-6.66-16.13c-2.23-5.38-4.47-10.75-6.53-16.18l-1.6-4.12a21.37,21.37,0,0,0-1.53-3.36,15.19,15.19,0,0,0-17.46-6.9l.34-.11-38,14.61-3.94,1.52L418.1,150l-2-3.16c-.66-1-1.36-2.22-1.89-2.94a6.17,6.17,0,0,0-1.39-1.41,6,6,0,0,0-1.8-.92,6.07,6.07,0,0,0-4,0l-6.77,2.63L372.1,154.59l-28.26,10.14-6.79,2.05a6.36,6.36,0,0,0-3.12,2.59,6.49,6.49,0,0,0-1,3.93c0,.69.27,2.12.43,3.33l.51,3.71.59,4.34-4.07,1.4-38.28,13.09.34-.14a10.75,10.75,0,0,0-4.21,3,12.45,12.45,0,0,0-2.45,4.89,17.89,17.89,0,0,0-.57,3,25.85,25.85,0,0,0-.15,3.11,18.41,18.41,0,0,0,1.33,6c3.27,9.51,6.49,18.89,9.62,28.39l4.74,14.21c1.53,4.77,2.9,9.6,4.26,14.43l7.88,28.95c-4.33-9-8.29-18.3-12-27.55l-5.75-13.79-5.58-13.9c-3.74-9.23-7.4-18.59-11-27.82a26.74,26.74,0,0,1-2.16-8.45,30.3,30.3,0,0,1,0-4.37,26.85,26.85,0,0,1,.62-4.38,21.61,21.61,0,0,1,3.89-8.54,19.86,19.86,0,0,1,7.59-5.92l.14-.06.2-.08,38-14.11-3.48,5.74-.57-3.69c-.16-1.27-.39-2.29-.55-4.09a17.29,17.29,0,0,1,10.64-17.25l1.37-.49.92-.29,1.79-.55,3.43-1.05,28-10.28,28.07-10,7.2-2.72A17,17,0,0,1,423,138c.91,1.32,1.41,2.31,2.08,3.39l1.92,3.22-6.26-2.16,38.39-13.66.19-.06.14,0a23.9,23.9,0,0,1,27.25,11.93,29.55,29.55,0,0,1,1.9,4.64l1.39,4.07,11.38,33c2,5.48,3.69,11.05,5.44,16.6l5.27,16.66C515.54,226.66,518.77,237.85,522,249.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.29,141.31c6-3.1,12.1-5.79,18.2-8.53l9.22-3.91c3.12-1.24,6.05-2.57,9.58-3.69a36.57,36.57,0,0,1,5.38-1.23,41.11,41.11,0,0,1,5.54-.35,32,32,0,0,1,11.17,2,28.64,28.64,0,0,1,16.21,16.06l.11.27.07.27c3.16,12.34,6.1,24.74,8.61,37.26,1.32,6.24,2.45,12.52,3.56,18.82s2.07,12.63,2.74,19c-2.52-5.93-4.68-11.95-6.85-18s-4.15-12.08-6-18.18c-3.89-12.15-7.35-24.42-10.59-36.74l.18.54a21.24,21.24,0,0,0-11.21-11.51A29.92,29.92,0,0,0,471,132c-2.91.56-6.2,1.67-9.41,2.49L451.92,137C445.41,138.53,438.92,140.12,432.29,141.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.6,
    cy: 161.53,
    r: 11.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.25,89.3c-.07-9.62-.2-20.7-.63-33.51L506.29,52l-3.47-.57a425.82,425.82,0,0,0-53.62-4.88A335.16,335.16,0,0,0,396.79,49c-17.35,2.24-34.6,6.23-50.83,12.91a124.3,124.3,0,0,0-23,12.54,92.13,92.13,0,0,0-19,17.77c11.85-12.74,27.21-21.43,43.32-27.08s33.18-8.64,50.23-10.19a351.46,351.46,0,0,1,51.41-.43A425.62,425.62,0,0,1,497.35,60s3,77.33,4.49,89.63a65.15,65.15,0,0,0,3.62,14.85l.06,19.48-.27,60.55c-.28,20.18-.38,40.36-.81,60.54l-.12,5.63-5.38-1.32a357,357,0,0,0-48.47-8.1,329.7,329.7,0,0,0-49.28-1.6,227.68,227.68,0,0,0-48.76,7,161.55,161.55,0,0,0-23.35,8.08,130.48,130.48,0,0,0-21.47,11.74l-3.44,4.12s84.9-30.13,218.39-4.08L524,89.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,183.06a57.92,57.92,0,1,1-19.16,3.28A57.9,57.9,0,0,1,408,183.06m0-6.65h0a64.53,64.53,0,1,0,60.88,43.18A64.49,64.49,0,0,0,408,176.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.24,292.86a63.8,63.8,0,0,1-94.79-44.69,64.26,64.26,0,0,1,.9-25.38,64.92,64.92,0,0,1,10.91-23.19A63.75,63.75,0,0,1,399,174.36a63.66,63.66,0,0,1,68.51,81.42A63.45,63.45,0,0,1,438.24,292.86Zm0,0A61.57,61.57,0,0,0,456.09,277a58.89,58.89,0,0,0-33.71-92.53,58.77,58.77,0,0,0-43.11,6.28,56.89,56.89,0,0,0-16.74,14.45,58.46,58.46,0,0,0-10.28,19.74,58.88,58.88,0,0,0,63.3,75.47A61.42,61.42,0,0,0,438.24,292.86Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.59315359912090422bf7937c29395e13.svg";
export { ForwardRef as ReactComponent };